// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

const fragments = {
	ITEM: '[data-fragment="AccordionGalleryTinySlider.item"]',
};

let tnsSlider = [];

export default class AccordionGalleryTinySlider extends WebComponent {

	didMount() {
		this.itemElement = this.element.querySelectorAll(fragments.ITEM);
		for(var i = 0; i < this.itemElement.length; i++) {
			tnsSlider.push(tns({
				container: this.itemElement[i].querySelector('.accordion__gallery'),
				controlsContainer: this.itemElement[i].querySelector('.slider__controls'),
				mode: 'gallery',
				items: 1,
				animateIn: 'fadeIn',
				speed: 600,
				animateOut: 'fadeOut',
				autoHeight: true,
				nav: false,
				slideBy: 'page',
				mouseDrag: true
			}));
		}

	}


}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/AccordionGalleryTinySlider.js